module.exports = __webpack_public_path__ + "img/ic_non_black.156fc2c2.svg";